import {Card, CardContent, Grid} from '@material-ui/core';
import classnames from 'classnames';
import {Formik, FormikHelpers, FormikProps} from 'formik';
import React, {ReactElement} from 'react';
import {useTranslation} from 'react-i18next';
import {Merchant} from '../../../shared/model/Merchant.model';
import PlatformType from '../../../shared/model/PlatformType.model';
import {TransHelper} from '../../../utils/trans-helper';
import NxButton from '../../shared/nxButton/NxButton';
import {NxFormikInput} from '../../shared/nxInput/NxFormikInput';
import {NxFormikSelect} from '../../shared/nxSelect/NxFormikSelect';
import {NxSelectOption} from '../../shared/nxSelect/NxSelect';
import styles from './ShopSettings.module.scss';
import {ShopFormFields, shopFormInitialValues, shopFormValidationSchema} from './ShopSettings.model';

type ShopProps = {
  merchant: Merchant;
  submit: (
    values: ShopFormFields,
    actions: FormikHelpers<ShopFormFields>
  ) => Promise<void>
}

export const MERCHANT_SHOP_ERROR_KEY = 'merchant_shop_error';

const PrefixTrans = TransHelper.getPrefixedTrans('SETTINGS.SHOP');

export default function ShopForm({merchant, submit}: ShopProps): React.ReactElement {

  const {t} = useTranslation();

  const platformOptions: NxSelectOption[] =
    Object.keys(PlatformType).map(platform => ({
      label: t(`SHARED.PLATFORMS.${platform}`),
      value: platform
    } as NxSelectOption));

  return (
    <Formik enableReinitialize={true}
            initialValues={shopFormInitialValues(merchant)}
            onSubmit={submit}
            validateOnMount={false}
            validateOnBlur={false}
            validateOnChange={false}
            validationSchema={shopFormValidationSchema(t)}>
      {
        ({handleSubmit, errors, isSubmitting}: FormikProps<ShopFormFields>): ReactElement => (
          <form onSubmit={handleSubmit}>
            <Grid container className={classnames(styles.root, styles.settingsRules)}>
              <Grid item xs={6} className={styles.item}>
                <Card variant='outlined' classes={{root: styles.card}}>
                  <CardContent classes={{root: styles.cardContent}}>
                    <div className={styles.title}>
                      <PrefixTrans>TITLE</PrefixTrans>
                    </div>
                    <NxFormikInput className={styles.input}
                                   name='name'
                                   label={<PrefixTrans>NAME</PrefixTrans>} />
                    <NxFormikInput className={styles.input}
                                   name={'websiteUrl'}
                                   label={<PrefixTrans>URL</PrefixTrans>} />
                    <NxFormikSelect className={styles.input}
                                    options={platformOptions}
                                    name='platform'
                                    label={<PrefixTrans>PLATFORM</PrefixTrans>} />
                    <div className={styles.error}>{errors[MERCHANT_SHOP_ERROR_KEY]}</div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
            <div className={styles.buttonRow}>
              <NxButton className={styles.button} loaded={!isSubmitting} type='submit'>
                <PrefixTrans>SUBMIT</PrefixTrans>
              </NxButton>
            </div>
          </form>
        )
      }
    </Formik>
  );
}